class StreakView {
  _streak = document.querySelector('.streak-number');

  render(state) {
    this._streak.textContent = state.streak;
  }
}

export default new StreakView();
